module.exports = __webpack_public_path__ + "static/media/level-tooeasy.50344cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/rating/img/level-tooeasy.png
// module id = 2087
// module chunks = 0